import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CronGenerator from "../CronGenarator";
import { ActionJobContext } from "./ActionJobContext";

const ModelCron = () => {
    const toast = useRef(null);
    const [value, setValue] = useState(null);
    const { t, i18n } = useTranslation(["action-job", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const actionJobContext = useContext(ActionJobContext);
    const { actionJobs, setActionJobs, cronDialog, setCronDialog, actionJob, setActionJob, index, setIndex } = actionJobContext;

    useEffect(() => {
        if (actionJob?.job?.cronExpression) {
            setValue(actionJob?.job?.cronExpression);
        } else {
            setValue(null);
        }
    }, [actionJob]);

    const hideDialog = () => {
        setIndex(-1);
        setActionJob(null);
        setCronDialog(false);
    };

    const saveCron = () => {
        const jobs = actionJobs;
        const x = jobs[index];
        const obj = {
            ...x,
            job: {
                ...x.job,
                cronExpression: value,
            },
        };
        jobs[index] = { ...obj };

        setActionJobs(jobs);

        setIndex(-1);
        setActionJob(null);
        setCronDialog(false);
    };

    return (
        <Dialog visible={cronDialog} style={{ width: "50%" }} header={"TIME GENERATOR".toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="formgrid">
                <div className="grid text-left">
                    <div className="col-12">
                        <CronGenerator
                            onChange={(e) => {
                                setValue(e);
                            }}
                            showResultText={true}
                            showResultCron={true}
                            value={value}
                        ></CronGenerator>
                    </div>
                    <div className="col-12 text-center">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2"
                            label={t("save", { ns: "common" })}
                            icon="pi pi-check"
                            onClick={saveCron}
                        />
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ModelCron;
